import { render, staticRenderFns } from "./companyComponent.vue?vue&type=template&id=447e576c&scoped=true&"
import script from "./companyComponent.vue?vue&type=script&lang=js&"
export * from "./companyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447e576c",
  null
  
)

export default component.exports